import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-app",
  "use": "icon-app-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-app\"><path d=\"M777.813333 0H246.186667C192.853333 0 149.333333 43.178667 149.333333 96v832C149.333333 980.821333 192.853333 1024 246.186667 1024h531.626666c53.205333 0 96.853333-43.178667 96.853334-96V96C874.666667 43.178667 831.018667 0 777.813333 0zM382.890667 48h258.218666v32H382.890667v-32zM447.445333 896c0-35.328 28.885333-64 64.554667-64 35.541333 0 64.554667 28.672 64.554667 64s-29.013333 64-64.554667 64A64.298667 64.298667 0 0 1 447.445333 896z m-233.557333-128V128h596.224v640H213.888z\" p-id=\"6502\" fill=\"#ffffff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/sidebar/app.svg
// module id = XX1k
// module chunks = 73